import {GeneralAmenitySelectedType} from "@CheckOrder/features/amenities/types/GeneralAmenitySelected.type";
import useGetPriceInUserCurrencyPerSelectedAmenity
    from "@CheckOrder/features/paymentSummary/features/amenitiesSummary/hooks/useGetPriceInUserCurrencyPerSelectedAmenity";
import roundToTwoDecimals from "@Number/roundToTwoDecimals";
import {useAppSelector} from "@Hooks/selector/useAppSelector";

/**
 * Sums up total amenity price (includes both single and return, if return exists)
 */
export default function useGetTotalPriceForSelectedAmenities() {
    const {
        singleSelectedAmenities,
        returnSelectedAmenities,
    } = useAppSelector((state) => state?.checkOrder.ticket);

    const {getPriceInUserCurrencyPerSelectedSingleAmenity} = useGetPriceInUserCurrencyPerSelectedAmenity()

    /**
     * receives a list of amenities and returns their total price in user's currency
     */
    const getTotalPriceFromAmenities = (amenities: GeneralAmenitySelectedType[], direction: "single" | "return") => {
        return roundToTwoDecimals(amenities.reduce((acc: number, amenity) => (
            getPriceInUserCurrencyPerSelectedSingleAmenity(amenity.key, direction) * amenity.value + acc
        ), 0))
    }

    const getTotalPriceForSelectedAmenities = () => {
        let priceFloat = 0;
        if (singleSelectedAmenities) {
            priceFloat += getTotalPriceFromAmenities(Object.entries(singleSelectedAmenities).map(([_key, amenity]) => (
                amenity
            )), "single")
        }
        if (returnSelectedAmenities) {
            priceFloat += getTotalPriceFromAmenities(Object.entries(returnSelectedAmenities).map(([_key, amenity]) => (
                amenity
            )), "return")
        }

        return priceFloat
    }

    return {
        getTotalPriceForSelectedAmenities,
    }
}